import React from 'react'
import { LoadingOutlined } from '@ant-design/icons';
import { Spin, Row, Col } from 'antd';
import './style.css'

export default function SplashView() {
    const antIcon = <LoadingOutlined style={{ fontSize: 24, color: "white" }} spin />;
    return <Row justify="center" align="middle" style={{ height: "100%", backgroundColor: "#5BBA47" }}>
        <Col>
            <img src={process.env.PUBLIC_URL + '/logo/apple-icon-120.png'} className="splash-logo" />
            <Spin indicator={antIcon} className="splash-loading" />
        </Col>
    </Row>
}
